<template>
  <div class="operation">
    <div class="row">
      <button
        type="button"
        class="btn btn-sm btn-primary mx-3"
        onclick="document.getElementById('import-shipping-spreadsheet').click()"
      >
        导入订单发货
      </button>
      <button
        type="button"
        class="btn btn-sm btn-primary"
        @click="
          showSuccessAlert('正在播放语音提示');
          speak('如果您听到了这段语音，那么表明您的电脑发货时会有语音提示');
        "
      >
        语音测试
      </button>
      <div v-if="selectedIds.length" class="form-inline">
        <label class="px-md-4" v-if="selectedIds.length"
          >{{ selectedIds.length }}个订单:
        </label>
        <button
          class="btn btn-sm btn-primary mr-3"
          type="button"
          @click="setOrdersStatus('sent')"
        >
          发货
        </button>
        <button
          class="btn btn-sm btn-primary mr-3"
          type="button"
          @click="setOrdersStatus('ship_no')"
        >
          移动到有运单号
        </button>
        <button
          class="btn btn-sm btn-primary mr-3"
          type="button"
          @click="setOrdersStatus('waiting')"
        >
          移动到订单不齐
        </button>
        <button
          class="btn btn-sm btn-primary mr-3"
          type="button"
          @click="setOrdersStatus('sent_wait')"
        >
          移动到待取件
        </button>
        <button
          class="btn btn-sm btn-primary mr-3"
          type="button"
          @click="setOrdersStatus('should_not_sent')"
        >
          移动到快递原因不能发货
        </button>
        <button
          class="btn btn-sm btn-primary mr-3"
          type="button"
          @click="printShippingTicket"
        >
          预览快递单
        </button>
      </div>
    </div>
    <div class="row mx-4">
      <div class="col-md-2 operation-zone">
        <div class="row">
          <form
            id="import-shipping-spreadsheet-form"
            enctype="multipart/form-data"
            method="post"
            action="/api/orders/spreadsheet"
          >
            <input
              accept=".xlsx"
              name="file"
              type="file"
              id="import-shipping-spreadsheet"
              style="display:none"
              v-on:change="$event.target.parentNode.submit()"
            />
            <input
              type="hidden"
              name="name"
              value="import-shipping-spreadsheet"
            />
          </form>
        </div>

        <div class="row my-4">
          <div class="input-group">
            <span class="input-group-prepend">
              <span class="input-group-text">筛单</span>
            </span>
            <input
              type="text"
              class="form-control"
              placeholder="请输入外部订单号"
              v-on:keyup.enter="filterOrder"
              v-model="hotOrderNo"
            />
          </div>
        </div>

        <form class="my-4">
          <div class="form-group row">
            <label class="col-md-4 col-form-label">扫码之后</label>
            <div class="col-md-8">
              <select class="custom-select" v-model="operation">
                <option value="shipNo" selected>生成快递单号</option>
                <option value="doNothing">显示订单信息</option>
              </select>
            </div>
          </div>

          <div v-if="operation === 'shipNo'">
            <div class="form-group row">
              <label
                class="col-md-4 col-form-label"
                v-b-tooltip.hover
                title="使用哪种快递"
                >快递使用</label
              >
              <div class="col-md-8">
                <select class="custom-select" id="ship-company">
                  <option value="default">默认</option>
                  <option value="yuantong">圆通</option>
                  <option value="zhongtong">中通</option>
                  <option value="youzheng">邮政快递包裹</option>
                  <option value="youzhengbiaokuai">邮政国内标快</option>
                  <option value="shentong">申通</option>
                  <option value="yunda">韵达</option>
                  <option value="shunfeng">顺丰</option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label
                class="col-md-4 col-form-label"
                v-b-tooltip.hover
                title="选中后，只为顺丰/非顺丰的订单生成快递单号"
                >筛选快递</label
              >
              <div class="col-md-8">
                <select class="custom-select" v-model="filterShipCompany">
                  <option value="all">所有</option>
                  <option value="not_shunfeng">非顺丰</option>
                  <option value="is_shunfeng">顺丰</option>
                </select>
              </div>
            </div>

            <div class="form-group row">
              <label
                class="col-md-4 col-form-label"
                v-b-tooltip.hover
                title="选中后，只为有附件/无附件的订单生成快递单号"
                >筛选附件</label
              >
              <div class="col-md-8">
                <select class="custom-select" v-model="filterExtra">
                  <option value="all">所有</option>
                  <option value="has_extra">有附件</option>
                  <option value="no_extra">无附件</option>
                </select>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="col-md-10">
        <div class="hot-order-divider row">
          <operation-order
            :order="order"
            v-for="order in this.orders"
            :key="order.order_no"
          ></operation-order>
        </div>
      </div>

      <div class="col-md-6">
        <div class="alert alert-primary">
          <p>1. 订单状态可以按需在下面任意切换</p>
          <p>2. 只有点击发货按钮之后, 订单号才会被反馈到第三方公司</p>
        </div>
      </div>
    </div>

    <div class="row">
      <div>
        <b-tabs content-class="mx-4">
          <b-tab title="每页最多显示100个" disabled>ssss</b-tab>
          <b-tab :title="`有运单号(${shipNoOrdersCount}个)`" active>
            <operation-table
              :orders="shipNoOrders"
              v-on:input-check="handleInputCheck"
            ></operation-table>
          </b-tab>

          <b-tab :title="`订单不齐(${waitingOrdersCount}个)`">
            <operation-table
              :orders="waitingOrders"
              v-on:input-check="handleInputCheck"
            ></operation-table>
          </b-tab>

          <b-tab :title="`待取件(${sentWaitOrdersCount}个)`">
            <operation-table
              :orders="sentWaitOrders"
              :count="sentWaitOrdersCount"
              v-on:input-check="handleInputCheck"
            ></operation-table>
          </b-tab>
          <b-tab :title="`快递原因不能发货(${shouldNotSentOrdersCount}个)`">
            <div class="alert alert-danger">
              快递原因不能发货的订单, 在订单页面不会用红色显示
            </div>
            <operation-table
              :orders="shouldNotSentOrders"
              :count="shouldNotSentOrdersCount"
              v-on:input-check="handleInputCheck"
            ></operation-table>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import { speak } from "@/utils/speak";
import OrderMixin from "@/mixins/order";
import { showFailedAlert, showSuccessAlert } from "@/utils/alert";
import OperationTable from "@/components/_operation/OperationTable";
import OperationOrder from "@/components/_operation/OperationOrder";

function filterOrder(event) {
  // 如果订单号包含#，忽略#以及后面的部分
  let nos = this.hotOrderNo.trim().split("#")[0];
  this.hotOrderNo = this.hotOrderNo.trim().split("#")[0];
  // 如果订单号W开头且后面是数字， 忽略W
  if (this.hotOrderNo.startsWith("W")) {
    this.hotOrderNo = this.hotOrderNo.slice(1, this.hotOrderNo.length);
  }
  nos += "," + this.hotOrderNo;

  this.$http
    .get("/api/orders?company_order_no__in=" + nos)
    .then(response => {
      this.hotOrderNo = "";
      this.orders = response.data.data;

      // 订单号数量问题检查
      if (this.orders.length === 0) {
        showFailedAlert("订单未找到");
        this.speak("订单未找到");
        this.order = null;
        return;
      } else if (this.orders.length > 1) {
        // 多个订单， 用户手动选择
        let orderNos = [];
        for (let i in response.data.data) {
          orderNos.push(
            response.data.data[i].company_code +
              " " +
              response.data.data[i].order_no
          );
        }
        const content = orderNos.join("\n");

        let result = prompt(
          `我们找到了多个订单， 请输入内部订单号以继续：\n${content}`
        ).trim();
        if (!result) {
          return;
        }

        let hasOrder = false;
        for (let i in response.data.data) {
          if (response.data.data[i].order_no === result) {
            this.order = response.data.data[i];
            hasOrder = true;
            break;
          }
        }

        if (!hasOrder) {
          return;
        }
      } else {
        this.order = response.data.data[0];
      }

      this.filterAndGenerateShipNo(this.order);
    })
    .catch(function(error) {
      console.log(error);
    });
}

function filterAndGenerateShipNo(order) {
  // 是否需要生成快递单号
  if (this.operation === "doNothing") {
    this.speak(this.order.admin_notes);
    this.speak(this.order.user_notes);
    for (const item of this.order.extra_items) {
      this.speak(item.name);
    }
    return;
  }

  //是否满足筛单条件
  let conditionShipCompany = order.ship_company.startsWith("shunfeng")
    ? "is_shunfeng"
    : "not_shunfeng";
  let conditionHasExtra =
    order.extra_items.length > 0 ? "has_extra" : "no_extra";

  let meetShipCompany = true;
  if (
    this.filterShipCompany !== "all" &&
    this.filterShipCompany !== conditionShipCompany
  ) {
    meetShipCompany = false;
  }

  let meetHasExtra = true;
  if (this.filterExtra !== "all" && this.filterExtra !== conditionHasExtra) {
    meetHasExtra = false;
  }

  if (!(meetHasExtra && meetShipCompany)) {
    let message = this.generateOrderFilterMessage(false, order);
    this.speak(message);
    showFailedAlert(message);
    this.$http.cancelSpin();
    return;
  }

  // 如果订单已发货， 报错
  if (order.status === "sent") {
    const message = "这个订单已经发货，不能生成快递单号";
    this.speak(message);
    showFailedAlert(message);
    return;
  } else if (this.order.status === "refunded") {
    showFailedAlert("这个订单已经退款");
    return;
  }

  // 如果订单已经有快递单号了，弹出确认对话框，之后强制获取新的快递单号
  let enforce = false;
  if (this.order.ship_no) {
    let content =
      this.getShipCompanyDisplay(this.order.ship_company) +
      ": " +
      this.order.ship_no;
    let success = confirm(
      "该订单已经有运单号\n " + content + "\n确认重新获取吗"
    );
    if (!success) {
      return;
    }
  }

  let shipCompany = document.querySelector("#ship-company").value || "default";
  // 顺丰优先
  if (this.order.ship_company === "shunfeng") {
    shipCompany = "shunfeng";
  } else if (this.order.ship_company === "shunfengguoji") {
    shipCompany = "shunfengguoji";
  } else if (shipCompany === "default") {
    shipCompany = this.order.ship_company;
  }

  this.GenerateShipNo(this.order.order_no, shipCompany, enforce);
}

function GenerateShipNo(orderNo, shipCompany, enforce = false) {
  this.$http.doSpin();
  this.$simpleHttp
    .post("/api/orders/" + orderNo + "/ship_no", {
      enforce: enforce,
      ship_company: shipCompany
    })
    .then(response => {
      setTimeout(this.refreshOrders, 2000);
      let message = this.generateOrderFilterMessage(true, response.data.data);
      message += ":" + response.data.data.ship_no;
      showSuccessAlert(message);
      this.$http.cancelSpin();
      this.speak("快递单号获取成功" + this.getShipCompanyDisplay(shipCompany));
      this.speak(this.order.admin_notes);
      this.speak(this.order.user_notes);
      for (const item of this.order.extra_items) {
        this.speak(item.name);
      }
    })
    .catch(function(error) {
      this.$http.cancelSpin();
      this.speak("快递单号获取失败");
      console.log(error);
    });
}

function printShippingTicket() {
  var orderNos = this.selectedIds;
  if (orderNos.length === 0) {
    return;
  }

  var url = "/tickets?order_nos=" + orderNos.join(",") + "&preview=true";
  window.open(url, "_blank");
}

function refreshOrdersByStatus(status, storageName) {
  this.$http
    .get(`/api/orders?status=${status}&ordering=-ship_no_at&size=100`)
    .then(response => {
      this[storageName] = response.data.data;
      this[storageName + "Count"] = response.data.count;
    })
    .catch(function(error) {
      console.log(error);
    });
}

function refreshOrders() {
  this.refreshOrdersByStatus("ship_no", "shipNoOrders");
  this.refreshOrdersByStatus("waiting", "waitingOrders");
  this.refreshOrdersByStatus("sent_wait", "sentWaitOrders");
  this.refreshOrdersByStatus("should_not_sent", "shouldNotSentOrders");
}

function setOrdersStatus(status) {
  let orderNos = this.selectedIds;
  if (!orderNos || orderNos.length === 0) {
    return;
  }

  if (status === "sent") {
    var result = confirm("确认发货？");
    if (!result) {
      return;
    }
  }

  this.$http
    .post("/api/orders/action", {
      order_nos: orderNos,
      operation: "set_status",
      data: {
        status: status
      }
    })
    .then(response => {
      // 设置未选中
      // this.flushSelectedIds()
      setTimeout(this.refreshOrders, 1000);
    });
}

function handleInputCheck(value) {
  this.selectedIds = value;
}

function generateOrderFilterMessage(success, order) {
  let message = "";

  if (!success) {
    message = "不满足筛单条件：";
  }

  if (order.extra_items.length > 0) {
    message += order.extra_items[0].name;
  } else {
    message += "无附件";
  }
  message += "," + this.getShipCompanyDisplay(order.ship_company);
  return message;
}

export default {
  name: "orders",
  mixins: [OrderMixin],
  data() {
    return {
      order: null,
      orders: [],
      operation: "shipNo",
      filterExtra: "all",
      filterShipCompany: "all",
      shipNoOrders: [],
      shipNoOrdersCount: 0,
      sentWaitOrders: [],
      sentWaitOrdersCount: 0,
      waitingOrders: [],
      waitingOrdersCount: 0,
      shouldNotSentOrders: [],
      shouldNotSentOrdersCount: 0,
      hotOrderNo: "",
      selectedIds: []
    };
  },
  methods: {
    filterOrder,
    filterAndGenerateShipNo,
    GenerateShipNo,
    generateOrderFilterMessage,
    printShippingTicket,
    refreshOrders,
    setOrdersStatus,
    handleInputCheck,
    speak,
    showSuccessAlert,
    refreshOrdersByStatus
  },
  components: {
    OperationTable,
    OperationOrder
  },
  mounted() {
    this.refreshOrders();
  }
};
</script>

<style lang="scss" scoped>
.operation-zone {
  height: 350px;
}

.line {
  margin: 20px 0;
}

label {
  font-weight: bold;
}

.process {
  z-index: 1000;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, 0);
}
</style>
